import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 24,
  medium: 18,
  small: 12,
  xSmall: 9
};
const InstagramFilledIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.4689 7C21.1949 7 22.5999 8.40397 22.5999 10.1308V20.0692C22.5999 21.796 21.1949 23.2 19.4689 23.2H9.5309C7.8049 23.2 6.3999 21.796 6.3999 20.0692V10.1308C6.3999 8.40397 7.8049 7 9.5309 7H19.4689ZM20.3669 8.86782L17.9789 8.87449L17.9879 11.6205L20.7249 11.6119V8.86591L20.3669 8.86782ZM12.1879 13.4369C11.8509 13.9056 11.6489 14.479 11.6489 15.1C11.6489 16.6716 12.9279 17.9508 14.4999 17.9508C16.0729 17.9508 17.3519 16.6716 17.3519 15.1C17.3519 14.479 17.1499 13.9056 16.8119 13.4369C16.2939 12.7188 15.4519 12.2482 14.4999 12.2482C13.5479 12.2482 12.7059 12.7188 12.1879 13.4369ZM21.0219 20.0692V13.437H18.6029C18.8109 13.9513 18.9299 14.5123 18.9299 15.1C18.9299 17.5422 16.9429 19.53 14.4999 19.53C12.0579 19.53 10.0709 17.5422 10.0709 15.1C10.0709 14.5123 10.1879 13.9513 10.3979 13.437H7.97791V20.0692C7.97791 20.9255 8.67491 21.6217 9.53091 21.6217H19.4689C20.3249 21.6217 21.0219 20.9255 21.0219 20.0692Z",
        fill: "currentColor"
      }
    )
  );
};
InstagramFilledIcon.iconName = "InstagramFilledIcon";

export { InstagramFilledIcon };
